import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Role} from '../auth/role';
import {RoleGuard} from '../auth/role-guard.service';
import {EmailComposerComponent} from './email-composer/email-composer.component';
import {EmailListIndexComponent} from './email-list-index/email-list-index.component';
import {EmailOptionsComponent} from './email-options/email-options.component';

const routes: Routes = [
    {
        path: 'email',
        canActivate: [RoleGuard],
        data: {allowed: [Role.EMAIL_SENDER]},
        children: [
            {path: '', component: EmailOptionsComponent},
            {path: 'listak', component: EmailListIndexComponent},
            {path: 'kuldes', component: EmailComposerComponent},
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmailRoutingModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-routing.module.ts